var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.text),function(block,idx){return _c('TemplateTextBlock',{key:idx,attrs:{"block":block}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }